"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InputBase_1 = __importDefault(require("@material-ui/core/InputBase"));
var react_1 = __importDefault(require("react"));
/********************
 * COLORS
 *******************/
var grey = {
    50: '#FAFCFF',
    100: '#F4F8FC',
    200: '#EBF1F6',
    300: '#DEE5ED',
    400: '#CAD5E0',
    500: '#AFBECD',
    600: '#8BA0B4',
    700: '#637D97',
    800: '#3F5B77',
    900: '#0A2642',
};
var blue = {
    50: '#E1F1FF',
    100: '#B7DCFF',
    200: '#87C6FF',
    300: '#4EAFFF',
    400: '#079EFF',
    500: '#008DFF',
    600: '#007EFF',
    700: '#006BED',
    800: '#0059DA',
    900: '#1537BB',
};
var red = {
    50: '#fef0f2',
    100: '#fca0a2',
    200: '#ff7679',
    300: '#e93b3f',
    400: '#d20004',
    500: '#bb000a',
};
var green = {
    50: '#bff5d3',
    100: '#83e3ab',
    200: '#65cd97',
    300: '#47B676',
    400: '#3ba06c',
    500: '#308252',
};
var purple = {
    50: '#efdeff',
    100: '#ddbeff',
    200: '#b380f6',
    300: '#8d58e2',
    400: '#6e2eb9',
    500: '#521687',
};
var teal = {
    50: '#c7f3f8',
    100: '#80deea',
    200: '#4dd0e1',
    300: '#00bcd4',
    400: '#00acc1',
    500: '#0097a7',
};
var orange = {
    50: '#f78812',
    100: '#ff6702',
    200: '#fa4515',
};
var pink = {
    50: '#ffbbc7',
    100: '#f787a9',
    200: '#ef538b',
};
var seagreen = {
    50: '#a7e9db',
    100: '#67d3bd',
    200: '#3cc5b3',
};
var yellow = {
    50: '#fdf7d0',
    100: '#fce984',
    200: '#fcca4e',
    300: '#ffab00'
};
var colors = {
    grey: grey,
    blue: blue,
    red: red,
    green: green,
    seagreen: seagreen,
    yellow: yellow,
    purple: purple,
    teal: teal,
    orange: orange,
    pink: pink,
    // deprecate this next major version
    error: red[400],
};
exports.colors = colors;
/********************
 * TYPOGRAPHY
 *******************/
var typography = {
    h1: {
        fontFamily: '"Libre Baskerville", serif',
        fontWeight: 'bold',
        fontSize: '48px',
        letterSpacing: '-1.02px',
        color: grey[800],
    },
    h2: {
        fontFamily: '"Libre Baskerville", serif',
        fontWeight: 'bold',
        fontSize: '40px',
        lineHeight: '48px',
        letterSpacing: '-0.85px',
        color: grey[800],
    },
    h3: {
        fontFamily: '"Libre Baskerville", serif',
        fontWeight: 'bold',
        fontSize: '30px',
        lineHeight: '40px',
        letterSpacing: '-0.5px',
        color: grey[800],
    },
    h4: {
        fontWeight: 'bold',
        fontSize: '30px',
        lineHeight: '40px',
        letterSpacing: '-0.28px',
        color: grey[800],
    },
    h5: {
        fontWeight: 'bold',
        fontSize: '24px',
        lineHeight: '32px',
        color: grey[800],
    },
    h6: {
        fontWeight: 'bold',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: '0.16px',
        color: grey[800],
    },
    subtitle1: {
        fontWeight: 'bold',
        fontSize: '15px',
        lineHeight: '20px',
        letterSpacing: '1.85px',
        textTransform: 'uppercase',
        color: grey[800],
    },
    subtitle2: {
        fontWeight: 500,
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: '0.16px',
        color: grey[800],
    },
    overline: {
        fontWeight: 'bold',
        fontSize: '13px',
        lineHeight: '16px',
        letterSpacing: '1.6px',
        textTransform: 'uppercase',
        color: grey[800],
    },
    body1: {
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        color: grey[800],
    },
    body2: {
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: '24px',
        color: grey[800],
    },
    button: {
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: '16px',
    },
    caption: {
        fontWeight: 500,
        fontSize: '13px',
        letterSpacing: '0.4px',
        lineHeight: '16px',
        color: grey[800]
    }
};
exports.typography = typography;
/********************
 * ELEVATION
 *******************/
var elevation = {
    normal: {
        0: 'none',
        1: 'inset 0 -1.5px 0 0 #E1E7ED, 0 1px 1px 0 rgba(0,32,64,0.07), 0 2px 1px -1px rgba(0,32,64,0.06), 0 1px 3px 0 rgba(0,32,64,0.07)',
        2: 'inset 0 -1.5px 0 0 #E1E7ED, 0 2px 2px 0 rgba(0,32,64,0.07), 0 3px 1px -2px rgba(0,32,64,0.06), 0 1px 5px 0 rgba(0,32,64,0.07)',
        3: 'inset 0 -1.5px 0 0 #E1E7ED, 0 3px 4px 0 rgba(0,32,64,0.07), 0 3px 3px -2px rgba(0,32,64,0.06), 0 1px 8px 0 rgba(0,32,64,0.07)',
        4: 'inset 0 -1.5px 0 0 #E1E7ED, 0 4px 5px 0 rgba(0,32,64,0.07), 0 1px 10px 0 rgba(0,32,64,0.06), 0 2px 4px -1px rgba(0,32,64,0.07)',
        6: 'inset 0 -1.5px 0 0 #E1E7ED, 0 6px 10px 0 rgba(0,32,64,0.07), 0 1px 18px 0 rgba(0,32,64,0.06), 0 3px 5px -1px rgba(0,32,64,0.07)',
        8: 'inset 0 -1.5px 0 0 #E1E7ED, 0 8px 10px 1px rgba(0,32,64,0.07), 0 3px 14px 2px rgba(0,32,64,0.06), 0 5px 5px -3px rgba(0,32,64,0.07)',
        9: 'inset 0 -1.5px 0 0 #E1E7ED, 0 9px 12px 1px rgba(0,32,64,0.07), 0 3px 16px 2px rgba(0,32,64,0.06), 0 5px 6px -3px rgba(0,32,64,0.07)',
        12: 'inset 0 -1.5px 0 0 #E1E7ED, 0 12px 17px 2px rgba(0,32,64,0.07), 0 5px 22px 4px rgba(0,32,64,0.06), 0 7px 8px -4px rgba(0,32,64,0.07)',
        16: 'inset 0 -1.5px 0 0 #E1E7ED, 0 12px 17px 2px rgba(0,89,218,0.04), 0 5px 22px 4px rgba(0,89,218,0.03), 0 7px 8px -4px rgba(0,89,218,0.04)',
        24: 'inset 0 1.5px 0 0 #E1E7ED, 0 -12px 17px 2px rgba(0,89,218,0.04), 0 -5px 22px 4px rgba(0,89,218,0.03), 0 -7px 8px -4px rgba(0,89,218,0.04)',
    },
    active: {
        6: 'inset 0 -1.5px 0 0 #DCEEFF, 0 6px 10px 0 rgba(0,89,218,0.07), 0 1px 18px 0 rgba(0,89,218,0.06), 0 3px 5px -1px rgba(0,89,218,0.07)',
        12: 'inset 0 -1.5px 0 0 #DCEEFF, 0 12px 17px 2px rgba(0,89,218,0.07), 0 5px 22px 4px rgba(0,89,218,0.06), 0 7px 8px -4px rgba(0,89,218,0.07)',
    },
};
exports.elevation = elevation;
var materialShadows = [
    elevation.normal[0],
    elevation.normal[1],
    elevation.normal[2],
    elevation.normal[3],
    elevation.normal[4],
    elevation.normal[4],
    elevation.normal[6],
    elevation.normal[6],
    elevation.normal[8],
    elevation.normal[9],
    elevation.normal[9],
    elevation.normal[9],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[12],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[16],
    elevation.normal[24],
];
/********************
 * MUI OVERRIDES
 *******************/
var outlinedButtonStyles = {
    border: "2px solid " + blue[800],
    color: blue[800],
    padding: '10px 24px',
    '&:hover': {
        backgroundColor: 'rgba(0,89,218,0.15) !important',
        border: "2px solid " + blue[800],
    },
    '&:focus': {
        backgroundColor: 'rgba(0,89,218,0.4) !important',
        border: "2px solid " + blue[800],
    },
    '&:active': {
        backgroundColor: 'rgba(0,89,218,0.4) !important',
        border: "2px solid " + blue[800],
    },
    '&:disabled': {
        color: grey[500],
        border: "2px solid " + grey[500],
    },
};
var fontFamilies = [
    'proxima-nova',
    'Montserrat',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    '"Helvetica Neue"',
    'Arial',
    'Roboto',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
];
var muiTheme = {
    typography: __assign({ fontFamily: fontFamilies.join(',') }, typography),
    shadows: materialShadows,
    palette: {
        primary: {
            light: blue[600],
            main: blue[800],
            dark: blue[900],
            contrastText: '#fff',
        },
        grey: grey,
        error: {
            main: red[400]
        },
    },
    props: {
        MuiButton: {
            disableRipple: true,
        },
        MuiInput: {
            disableUnderline: true,
        },
        MuiFilledInput: {
            disableUnderline: true,
        },
        MuiInputLabel: {
            shrink: true,
            disableAnimation: true,
            variant: 'standard',
        },
        MuiSelect: {
            input: react_1.default.createElement(InputBase_1.default),
        },
        MuiPaper: {
            square: true,
            elevation: 12,
        },
    },
    overrides: {
        MuiFormHelperText: {
            root: {
                color: colors.grey[800],
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: '16px',
                marginTop: '4px',
            },
            contained: {
                margin: '4px 0 0 0',
            },
        },
        MuiInputBase: {
            root: {
                fontSize: '17px',
                fontWeight: 500,
                lineHeight: '24px',
                padding: '8px 16px',
                color: grey[900],
                '&$disabled': {
                    color: grey[500],
                },
            },
            input: {
                padding: 0,
                '&::placeholder': {
                    color: grey[500],
                    opacity: 1,
                },
            },
        },
        MuiInput: {
            root: {
                transition: 'all 0.25s',
                borderBottom: "2px solid " + colors.grey[600],
                marginTop: '0 !important',
                '&$disabled': {
                    backgroundColor: colors.grey[300],
                    borderColor: colors.grey[400],
                },
                '&$focused': {
                    borderColor: colors.blue[800],
                },
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: '#fff !important',
                border: "1px solid " + colors.grey[400],
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                transition: 'all 0.25s',
                '&:hover': {
                    backgroundColor: '#fff',
                },
                '&$focused': {
                    boxShadow: elevation.active[6],
                    backgroundColor: '#fff',
                    borderBottom: "2px solid " + colors.blue[800],
                    paddingBottom: '7px',
                },
                '&$disabled': {
                    backgroundColor: colors.grey[300] + " !important",
                    borderColor: colors.grey[400],
                },
                '&$error': {
                    borderBottom: "2px solid " + colors.error,
                    paddingBottom: '7px',
                },
            },
            multiline: {
                padding: 0,
                '&$focused': {
                    paddingBottom: 0,
                    marginBottom: '-1px',
                },
            },
            inputMultiline: {
                padding: '8px 16px',
            },
            input: {
                padding: 0,
            },
        },
        MuiSelect: {
            root: {
                margin: '-8px -16px',
                padding: '8px 24px 8px 16px',
                transition: 'all 0.25s',
                borderBottom: "2px solid " + colors.grey[600],
                '&$disabled': {
                    backgroundColor: colors.grey[300],
                    borderColor: colors.grey[400],
                },
            },
            icon: {
                color: colors.grey[600],
            },
            input: {
                borderBottom: 0,
            },
            select: {
                '&:focus': {
                    borderColor: colors.blue[800],
                    backgroundColor: 'none !important',
                },
            },
            filled: {
                backgroundColor: '#fff',
                border: "1px solid " + colors.grey[400],
                '&:focus': {
                    boxShadow: elevation.active[6],
                    borderColor: colors.grey[400],
                    borderBottom: "2px solid " + colors.blue[800],
                    paddingBottom: '7px',
                },
            },
        },
        MuiMenuItem: {
            root: {
                textTransform: 'none',
            },
        },
        MuiInputAdornment: {
            root: {
                color: grey[500],
            },
            positionStart: {
                marginLeft: '-8px',
                marginTop: '0 !important',
            },
            positionEnd: {
                marginRight: '-8px',
            },
        },
        MuiInputLabel: {
            root: __assign({}, typography.body1, { position: 'relative !important', '&$focused': {
                    color: colors.blue[800],
                }, '&$disabled': {
                    color: colors.grey[800],
                } }),
            shrink: {
                transform: 'none',
            },
        },
        MuiButton: {
            root: {
                padding: '12px 24px',
                borderRadius: '20px',
                textTransform: 'none',
            },
            outlined: outlinedButtonStyles,
            outlinedPrimary: outlinedButtonStyles,
            outlinedSecondary: {
                border: "2px solid #fff",
                color: '#fff',
                padding: '10px 24px',
                '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.25)',
                    border: "2px solid #fff",
                },
                '&:focus': {
                    backgroundColor: 'rgba(255,255,255,0.65)',
                    border: "2px solid #fff",
                },
                '&:active': {
                    backgroundColor: 'rgba(255,255,255,0.65)',
                    border: "2px solid #fff",
                },
                '&:disabled': {
                    opacity: 0.5,
                    color: '#fff',
                    border: '2px solid #fff',
                },
            },
            contained: {
                backgroundColor: '#fff',
                color: blue[800],
                padding: '12px 24px',
                boxShadow: elevation.normal[12],
                // this is the default but with the box-shadow lowered from 250ms to 100ms
                transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n                     box-shadow       100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n                     border           250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                '&:hover': {
                    backgroundColor: '#fff !important',
                    boxShadow: elevation.active[12],
                },
                '&:focus': {
                    backgroundColor: '#fff',
                    boxShadow: elevation.active[6] + " !important",
                },
                '&:active': {
                    backgroundColor: '#fff',
                    boxShadow: elevation.active[6] + " !important",
                },
                '&:disabled': {
                    color: grey[500],
                },
            },
            containedPrimary: {
                backgroundColor: blue[800],
                color: '#fff',
                padding: '12px 24px',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: blue[600] + " !important",
                    boxShadow: 'none',
                },
                '&:focus': {
                    backgroundColor: blue[900] + " !important",
                    boxShadow: 'none !important',
                },
                '&:active': {
                    backgroundColor: blue[900] + " !important",
                    boxShadow: 'none !important',
                },
                '&:disabled': {
                    color: '#fff',
                    backgroundColor: grey[500] + " !important",
                    boxShadow: 'none',
                },
            },
            containedSecondary: {
                backgroundColor: '#fff',
                color: blue[800],
                padding: '12px 24px',
                boxShadow: 'none !important',
                '&:hover': {
                    backgroundColor: blue[50] + " !important",
                    boxShadow: 'none !important',
                },
                '&:focus': {
                    backgroundColor: blue[200] + " !important",
                    boxShadow: 'none !important',
                },
                '&:active': {
                    backgroundColor: blue[200] + " !important",
                    boxShadow: 'none !important',
                },
                '&:disabled': {
                    color: grey[500],
                    backgroundColor: '#fff',
                },
            },
        },
        MuiAppBar: {
            root: {
                boxShadow: elevation.normal[16],
            },
        },
        MuiToolbar: {
            root: {
                backgroundColor: '#fff',
            },
        },
        MuiChip: {
            root: {
                borderRadius: '4px',
                backgroundColor: grey[600],
                height: 'auto',
            },
            label: {
                color: '#fafdff',
                paddingTop: '4px',
                paddingBottom: '4px',
            },
        },
        // MuiPickers is not part of the MUI core package.
        MuiPickersToolbarText: {
            toolbarTxt: {
                fontFamily: fontFamilies.join(','),
            },
        },
    },
};
exports.default = muiTheme;
